var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"contents"}},[_c('div',{staticClass:"asideBox-block"},[_c('recommendedLinks'),_vm._v(" "),_c('topRewards'),_vm._v(" "),_c('mobileInfo')],1),_vm._v(" "),_c('div',{staticClass:"betslip-block"},[_c('BetSlip',{ref:"BetSlip"})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cda6ed4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/account/accountWidgets.vue
// module id = Z61q
// module chunks = 0